import React from 'react';
import { Outlet, Navigate } from 'react-router-dom';
import { getStorage } from '../utils/functions/localstorage';

const useAuth = () => {
  const token = getStorage('token');
  return token;
};

function ProtectedRoutes() {
  const isAuth = useAuth();
  return isAuth ? <Outlet /> : <Navigate to="/login-admin" />;
}

export default ProtectedRoutes;
